/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Fairuse_Section4body32Inputs */

const id_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dalam hal aset grafis, kami memuat gambar langsung dari server Epic Games Store. Kami tidak menyimpan gambar apa pun di server kami.`)
};

const ms_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari segi aset grafik, kami memuatkan imej terus dari pelayan Epic Games Store. Kami tidak menyimpan sebarang imej pada pelayan kami.`)
};

const da_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvad angår grafiske aktiver, indlæser vi billederne direkte fra Epic Games Stores servere. Vi gemmer ingen billeder på vores servere.`)
};

const de_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei grafischen Assets laden wir die Bilder direkt von den Servern des Epic Games Store. Wir speichern keine Bilder auf unseren Servern.`)
};

const en_us2_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In terms of graphical assets, we load the images from the Epic Games Store servers directly. We do not store any images on our servers.`)
};

const es_es2_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cuanto a los recursos gráficos, cargamos las imágenes directamente desde los servidores de la Epic Games Store. No almacenamos ninguna imagen en nuestros servidores.`)
};

const es_mx2_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cuanto a los recursos gráficos, cargamos las imágenes directamente desde los servidores de la Epic Games Store. No almacenamos ninguna imagen en nuestros servidores.`)
};

const fil_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sa usapin ng graphical assets, nilo-load namin ang mga larawan nang direkta mula sa mga server ng Epic Games Store. Hindi kami nag-iimbak ng anumang larawan sa aming mga server.`)
};

const fr_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En ce qui concerne les ressources graphiques, nous chargeons les images directement depuis les serveurs de l'Epic Games Store. Nous ne stockons aucune image sur nos serveurs.`)
};

const it_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per quanto riguarda le risorse grafiche, carichiamo le immagini direttamente dai server dell'Epic Games Store. Non memorizziamo alcuna immagine sui nostri server.`)
};

const hu_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A grafikus eszközök tekintetében a képeket közvetlenül az Epic Games Store szervereiről töltjük be. Nem tárolunk képeket a saját szervereinken.`)
};

const nl_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat grafische assets betreft, laden we de afbeeldingen rechtstreeks van de servers van de Epic Games Store. We slaan geen afbeeldingen op onze servers op.`)
};

const no_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Når det gjelder grafiske eiendeler, laster vi bildene direkte fra Epic Games Store-serverne. Vi lagrer ingen bilder på våre servere.`)
};

const pl_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeśli chodzi o zasoby graficzne, ładujemy obrazy bezpośrednio z serwerów Epic Games Store. Nie przechowujemy żadnych obrazów na naszych serwerach.`)
};

const pt_br2_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em relação aos assets gráficos, carregamos as imagens diretamente dos servidores da Epic Games Store. Não armazenamos nenhuma imagem em nossos servidores.`)
};

const pt_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em termos de recursos gráficos, carregamos as imagens diretamente dos servidores da Epic Games Store. Não armazenamos nenhuma imagem nos nossos servidores.`)
};

const ro_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`În ceea ce privește activele grafice, încărcăm imaginile direct de pe serverele Epic Games Store. Nu stocăm nicio imagine pe serverele noastre.`)
};

const fi_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graafisten resurssien osalta lataamme kuvat suoraan Epic Games Storen palvelimilta. Emme tallenna kuvia omille palvelimillemme.`)
};

const sv_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`När det gäller grafiska tillgångar laddar vi bilderna direkt från Epic Games Stores servrar. Vi lagrar inga bilder på våra servrar.`)
};

const vi_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Về tài nguyên đồ họa, chúng tôi tải hình ảnh trực tiếp từ máy chủ của Epic Games Store. Chúng tôi không lưu trữ bất kỳ hình ảnh nào trên máy chủ của mình.`)
};

const tr_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grafik varlıkları açısından, görselleri doğrudan Epic Games Store sunucularından yüklüyoruz. Sunucularımızda hiçbir görsel depolamıyoruz.`)
};

const cs_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokud jde o grafické assety, načítáme obrázky přímo ze serverů Epic Games Store. Na našich serverech neukládáme žádné obrázky.`)
};

const bg_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Що се отнася до графичните активи, ние зареждаме изображенията директно от сървърите на Epic Games Store. Не съхраняваме никакви изображения на нашите сървъри.`)
};

const ru_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что касается графических ресурсов, мы загружаем изображения непосредственно с серверов Epic Games Store. Мы не храним никаких изображений на наших серверах.`)
};

const uk_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Щодо графічних ресурсів, ми завантажуємо зображення безпосередньо з серверів Epic Games Store. Ми не зберігаємо жодних зображень на наших серверах.`)
};

const ar_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فيما يتعلق بالأصول الرسومية، نقوم بتحميل الصور مباشرة من خوادم Epic Games Store. لا نخزن أي صور على خوادمنا.`)
};

const hi_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हम छवियों को सीधे सर्वर से लोड करते हैं।`)
};

const th_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ในส่วนของทรัพยากรกราฟิก เราจะโหลดรูปภาพจากเซิร์ฟเวอร์ของ Epic Games Store โดยตรง เราไม่ได้จัดเก็บรูปภาพใด ๆ บนเซิร์ฟเวอร์ของเรา`)
};

const ja_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グラフィカルアセットについては、Epic Games Store のサーバーから直接画像を読み込みます。当社のサーバーに画像を保存することはありません。`)
};

const zh_cn2_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在图形资源方面，我们直接从Epic游戏商城的服务器加载图片，不会在我们的服务器上存储任何图片。`)
};

const zh_hant1_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在圖形資源方面，我們直接從Epic遊戲商城的伺服器載入圖片，不會在我們的伺服器上儲存任何圖片。`)
};

const ko_misc_fairuse_section4body32 = /** @type {(inputs: Misc_Fairuse_Section4body32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그래픽 에셋의 경우 Epic Games Store 서버에서 직접 이미지를 로드합니다. 당사 서버에 이미지를 저장하지 않습니다.`)
};

/**
* | output |
* | --- |
* | "In terms of graphical assets, we load the images from the Epic Games Store servers directly. We do not store any images on our servers." |
*
* @param {Misc_Fairuse_Section4body32Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_fairuse_section4body32 = /** @type {((inputs?: Misc_Fairuse_Section4body32Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Fairuse_Section4body32Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_fairuse_section4body32(inputs)
	if (locale === "ms") return ms_misc_fairuse_section4body32(inputs)
	if (locale === "da") return da_misc_fairuse_section4body32(inputs)
	if (locale === "de") return de_misc_fairuse_section4body32(inputs)
	if (locale === "en-US") return en_us2_misc_fairuse_section4body32(inputs)
	if (locale === "es-ES") return es_es2_misc_fairuse_section4body32(inputs)
	if (locale === "es-MX") return es_mx2_misc_fairuse_section4body32(inputs)
	if (locale === "fil") return fil_misc_fairuse_section4body32(inputs)
	if (locale === "fr") return fr_misc_fairuse_section4body32(inputs)
	if (locale === "it") return it_misc_fairuse_section4body32(inputs)
	if (locale === "hu") return hu_misc_fairuse_section4body32(inputs)
	if (locale === "nl") return nl_misc_fairuse_section4body32(inputs)
	if (locale === "no") return no_misc_fairuse_section4body32(inputs)
	if (locale === "pl") return pl_misc_fairuse_section4body32(inputs)
	if (locale === "pt-BR") return pt_br2_misc_fairuse_section4body32(inputs)
	if (locale === "pt") return pt_misc_fairuse_section4body32(inputs)
	if (locale === "ro") return ro_misc_fairuse_section4body32(inputs)
	if (locale === "fi") return fi_misc_fairuse_section4body32(inputs)
	if (locale === "sv") return sv_misc_fairuse_section4body32(inputs)
	if (locale === "vi") return vi_misc_fairuse_section4body32(inputs)
	if (locale === "tr") return tr_misc_fairuse_section4body32(inputs)
	if (locale === "cs") return cs_misc_fairuse_section4body32(inputs)
	if (locale === "bg") return bg_misc_fairuse_section4body32(inputs)
	if (locale === "ru") return ru_misc_fairuse_section4body32(inputs)
	if (locale === "uk") return uk_misc_fairuse_section4body32(inputs)
	if (locale === "ar") return ar_misc_fairuse_section4body32(inputs)
	if (locale === "hi") return hi_misc_fairuse_section4body32(inputs)
	if (locale === "th") return th_misc_fairuse_section4body32(inputs)
	if (locale === "ja") return ja_misc_fairuse_section4body32(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_fairuse_section4body32(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_fairuse_section4body32(inputs)
	return ko_misc_fairuse_section4body32(inputs)
});
export { misc_fairuse_section4body32 as "misc.fairUse.section4Body3" }